import type { RouterOutputs } from "@/types/rpc";

export type CompanyMatch = RouterOutputs["music"]["searchCompanies"][number];
export type RelatedEntityKind = "imprint" | "company" | "mixed";
export type RelatedEntity = CompanyMatch & { kind: RelatedEntityKind };

export function mergeRelatedSearchEntities(
  labels: CompanyMatch[],
  companies: CompanyMatch[],
): RelatedEntity[] {
  const byId = new Map<string, RelatedEntity>();
  for (const [entities, kind] of [
    [labels, "imprint"],
    [companies, "company"],
  ] as const) {
    for (const entity of entities) {
      const current = byId.get(entity.id);
      if (!current) {
        byId.set(entity.id, { ...entity, kind });
      } else if (current.kind !== kind) {
        byId.set(entity.id, { ...current, kind: "mixed" });
      }
    }
  }
  return [...byId.values()];
}
